/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RouteToMarketEnum = 'DIRECT' | 'RESELLER' | 'DISTRIBUTOR' | 'MSP';

export const RouteToMarketEnum = {

    DIRECT: 'DIRECT' as RouteToMarketEnum,

    RESELLER: 'RESELLER' as RouteToMarketEnum,

    DISTRIBUTOR: 'DISTRIBUTOR' as RouteToMarketEnum,

    MSP: 'MSP' as RouteToMarketEnum
};

